// Home.toolbar

module.exports = {
  create: {
    en: "Create",
    fr: "Créer"
  },
  back: {
    en: "Back",
    fr: "Retour"
  },
  plateform: {
    en: " to Platform",
    fr: " à l'onglet Plateforme"
  },
  group: {
    en: " to Group",
    fr: " à l'onglet Groupe"
  }
};
